import { render, staticRenderFns } from "./tabWarning.vue?vue&type=template&id=58674d00&"
import script from "./tabWarning.vue?vue&type=script&lang=js&"
export * from "./tabWarning.vue?vue&type=script&lang=js&"
import style0 from "./tabWarning.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58674d00')) {
      api.createRecord('58674d00', component.options)
    } else {
      api.reload('58674d00', component.options)
    }
    module.hot.accept("./tabWarning.vue?vue&type=template&id=58674d00&", function () {
      api.rerender('58674d00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/WarningPending/components/tabWarning.vue"
export default component.exports